import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import { PermissionData } from '../../api/types';
import { CustomAlert } from '../CustomComponents/CustomComponents';
import { LinkIcon } from '../LinkIcon/LinkIcon';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { PermissionsMissingSecondary } from './PermissionsMissingSecondary';

interface PermissionsMissingValueProps {
    accessPointCode: string;
    missingKey: 'missingRanks' | 'missingPermits';
    permissionInfo: PermissionData;
    readOnly: boolean;
    subtitle: string;
    translations: Record<string, string>;
}

export const PermissionsMissingValue: React.FC<PermissionsMissingValueProps> = ({
    accessPointCode,
    readOnly,
    permissionInfo,
    subtitle,
    missingKey,
    translations,
}) => {
    if (!permissionInfo[missingKey]?.length) {
        return null;
    }

    const alert = (
        <CustomAlert icon={false} severity="error">
            <Grid container alignItems="center">
                <Grid
                    item
                    xs={11}
                    style={{
                        flexFlow: 'column',
                    }}
                >
                    <Typography variant="body1">
                        {missingKey === 'missingRanks'
                            ? translations.PERMISSIONS_MISSING_RANKS_TITLE
                            : translations.PERMISSIONS_MISSING_PERMITS_TITLE}
                        {missingKey === 'missingRanks' && !readOnly && <LinkIcon link={permissionInfo.trainingLink} />}
                    </Typography>

                    <PermissionsMissingSecondary permissionInfo={permissionInfo} missingKey={missingKey} />
                    {!readOnly && (
                        <Typography variant="caption" color="textSecondary">
                            {subtitle}
                        </Typography>
                    )}
                </Grid>
                {!readOnly && (
                    <Grid item xs={1} style={{ justifyContent: 'flex-end' }}>
                        <Typography>
                            <ChevronRightIcon />
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </CustomAlert>
    );

    return readOnly ? (
        alert
    ) : (
        <LinkWrapper
            to={
                missingKey === 'missingRanks'
                    ? permissionInfo.trainingLink
                    : `/accesspoint/${accessPointCode}/permissions/${permissionInfo.permissionCode}/permits`
            }
            translations={translations}
        >
            {alert}
        </LinkWrapper>
    );
};
